<script>
  import Modal from "./../../../shared/Modal.svelte";
  import { link } from "svelte-spa-router";
  import { Circle } from "svelte-loading-spinners";
  import { createEventDispatcher, onMount } from "svelte";
  import axios from "axios";
  import * as ls from "local-storage";
  import config from "../../../stores/config";

  const dispatch = createEventDispatcher();
  const authData = { headers: { authorization: ls.get("jwt") } };

  export let customerID;

  export let materialReq;

  export let orderNumber;
  export let orderID;
  export let _id;
  export let uPrice;
  export let qtyOrdered;
  export let qtyMade;
  export let rejects;
  export let reworks;
  export let cutSheetN;
  export let fStyleID;
  export let cmtID;
  export let expectedDeliveryDate;
  export let patternID;
  export let patternPieces;
  export let costingN;

  let currStyle = $config?.fstyles?.find(({ value }) => value == fStyleID);

  let inventoryLevel = currStyle?.inventoryLevel;
  let fStyleName = currStyle?.label;
  let cmtName = $config?.cmts?.find(({ value }) => value == cmtID)?.label;
  let size = currStyle?.size;
  let SKU = currStyle?.SKU;
  let baseReq = currStyle?.materialReq;

  //--------------------------------------------------------------------------------------

  let editedStyle = {
    qtyOrdered,
    qtyMade,
    rejects,
    reworks,
    uPrice,
    cutSheetN,
    expectedDeliveryDate,
  };

  let showEditStyleForm = false;
  let editStyleLoading = false;

  const handleEditStyle = async (e) => {
    if (editedStyle.qtyOrdered == undefined)
      alert("⚠ Quantity Ordered missing!");
    else if (editedStyle.qtyMade == undefined)
      alert("⚠ Quantity made missing!");
    else if (editedStyle.rejects == undefined) alert("⚠ Rejects missing!");
    else if (editedStyle.reworks == undefined) alert("⚠ Reworks missing!");
    else if (editedStyle.uPrice == undefined) alert("⚠ Unite Price missing!");
    else if (editedStyle.expectedDeliveryDate == undefined)
      alert("⚠ Expected delivery date missing!");
    else {
      editStyleLoading = true;

      if (materialReq?.length > 0 && editedStyle.qtyOrdered != qtyOrdered) {
        materialReq = materialReq.map((m) => {
          let qtyPerStyle = baseReq.find((r) => r.itemID == m.itemID).qtyReq;

          return {
            ...m,
            qtyReq:
              m.qtyReq + qtyPerStyle * (editedStyle.qtyOrdered - qtyOrdered),
          };
        });
      }

      let data = { ...editedStyle, materialReq };

      axios
        .put(
          `${$config.backendURL}/orders/${orderID}/edit-style/${_id}`,
          data,
          authData
        )
        .then((res) => {
          showEditStyleForm = false;
          editStyleLoading = false;
          dispatch("update");
        })
        .catch((err) => {
          console.log(err);
        });
    }
  };

  const handleDelete = () => {
    let confirmDelete = confirm(`Do you wish to delete this style?`);

    if (confirmDelete) {
      axios
        .delete(
          `${$config.backendURL}/orders/${orderID}/delete-style/${_id}`,
          authData
        )
        .then((res) => {
          dispatch("delete");
        })
        .catch((err) => {
          console.log(err);
          alert(err);
        });
    }
  };

  const handleAssign = () => {
    let qty = prompt(
      `\n🟢 ${inventoryLevel} of ${fStyleName} were found in stock. \n\nHow many do you wish to assign to this order?\n`
    );
    qty = qty.replaceAll(/[^\d.-]/g, "");

    if (qty > inventoryLevel) {
      alert(`You cannot assign more than What's available in Stock`);
      return;
    } else if (qtyOrdered - qtyMade - qty < 0) {
      alert(
        `Only ${
          qtyOrdered - qtyMade
        } of ${fStyleName} were ordered, you cannot assign ${qty} to this order`
      );
      return;
    }

    axios
      .put(
        `${$config.backendURL}/fstyles/increment/${fStyleID}`,
        { qty: qty * -1 },
        authData
      )
      .then((res) => {
        if (materialReq?.length > 0) {
          materialReq = materialReq.map((m) => {
            let qtyPerStyle = baseReq.find((r) => r.itemID == m.itemID).qtyReq;
            m.qtyReq -= qtyPerStyle * qty;
            return { ...m };
          });
        }

        axios
          .put(
            `${$config.backendURL}/orders/${orderID}/edit-style/${_id}`,
            {
              qtyMade: qtyMade + Number.parseInt(qty),
              qtyOrdered,
              rejects,
              reworks,
              uPrice,
              materialReq,
            },
            authData
          )
          .then((res) => {
            showEditStyleForm = false;
            editStyleLoading = false;
            window.location.reload();
          })
          .catch((err) => {
            console.log(err);
          });
      })
      .catch((err) => {
        console.log(err);
        alert(err);
      });
  };
</script>

<div class="tr tracking-wider border-b border-gray-100 ">
  <div style="min-width: 11rem; max-width: 11rem;" class="flex items-center">
    <button class="text-base btn btn-red-outline mr-2" on:click={handleDelete}>
      <i class="fas fa-trash" />
    </button>
    {#if qtyOrdered == qtyMade}
      <span class="text-base btn btn-green-outline mr-2 opacity-75">
        <i class="fas fa-check-circle" />
      </span>
    {:else}
      <a
        href={`/styles/${orderID}____${_id}`}
        use:link
        class="text-base btn btn-gray-outline mr-2"
      >
        <i class="fas fa-eye" />
      </a>
    {/if}
    <button
      class="text-base btn btn-green-outline mr-2"
      on:click={(e) => (showEditStyleForm = true)}
    >
      <i class="fas fa-edit" />
    </button>
  </div>
  <div style="min-width: 15rem; max-width: 15rem;">{cmtName}</div>
  <div style="min-width: 15rem; max-width: 15rem;" class="mr-4">
    {fStyleName}
  </div>
  {#if qtyOrdered != qtyMade}
    {#if inventoryLevel > 0}
      {inventoryLevel}
      <div
        style="min-width: 9rem; max-width: 9rem;"
        class="text-red-400 flex items-center justify-between pr-4"
      >
        <button class="ml-2 btn btn-green" on:click={handleAssign}>
          <i class="fas fa-plus-circle mr-3" />
          Assign
        </button>
      </div>
    {:else}
      <div
        style="min-width: 9rem; max-width: 9rem;"
        class="text-xs tracking-wider uppercase"
      >
        None In Stock
      </div>
    {/if}
  {:else}
    <div
      style="min-width: 9rem; max-width: 9rem;"
      class="text-xs tracking-wider uppercase text-green-500"
    >
      Complete
    </div>
  {/if}

  <div style="min-width: 7rem; max-width: 7rem;">{size}</div>
  <div style="min-width: 8rem; max-width: 8rem;">{SKU}</div>
  <div style="min-width: 8.5rem; max-width: 8.5rem;">
    {expectedDeliveryDate}
  </div>
  <div style="min-width: 7rem; max-width: 7rem;">R{uPrice}</div>
  <div style="min-width: 7rem; max-width: 7rem;">{qtyOrdered}</div>

  <div style="min-width: 7rem; max-width: 7rem;">{qtyMade}</div>
  <div style="min-width: 7rem; max-width: 7rem;">
    R{(qtyOrdered * uPrice).toFixed(2)}
  </div>
  <div style="min-width: 7rem; max-width: 7rem;">
    {qtyOrdered - qtyMade}
  </div>
  <div style="min-width: 7rem; max-width: 7rem;">{rejects}</div>
  <div style="min-width: 7rem; max-width: 7rem;">{reworks}</div>
  <div style="min-width: 7rem; max-width: 7rem;">{cutSheetN}</div>
</div>

<!-- EDIT MODAL -->
<Modal
  show={showEditStyleForm}
  on:modalClose={() => {
    showEditStyleForm = false;
  }}
>
  <div class="grid gap-y-2">
    <div class="flex items-center uppercase text-gray-600 mb-2">
      <i class="fas fa-info-circle mr-2" />
      {fStyleName} | {cmtName}
    </div>

    <div class="grid grid-cols-3 gap-2 items-center">
      <div>Cut Sheet Number :</div>
      <input
        class="col-span-2"
        bind:value={editedStyle.cutSheetN}
        type="text"
        placeholder="Cut Sheet Number"
      />
    </div>

    <div class="grid grid-cols-3 gap-2 items-center">
      <div>Quantity Ordered :</div>
      <input
        class="col-span-2"
        bind:value={editedStyle.qtyOrdered}
        type="number"
        step="any"
        placeholder="Quantity Ordered"
      />
    </div>

    <div class="grid grid-cols-3 gap-2 items-center">
      <div>Expected Delivery Date :</div>
      <input
        class="col-span-2"
        bind:value={editedStyle.expectedDeliveryDate}
        type="date"
        placeholder="Expected Delivery Date"
      />
    </div>

    <div class="grid grid-cols-3 gap-2 items-center">
      <div>Quantity Made :</div>
      <input
        class="col-span-2"
        bind:value={editedStyle.qtyMade}
        type="number"
        step="any"
        placeholder="Quantity Made"
      />
    </div>

    <div class="grid grid-cols-3 gap-2 items-center">
      <div>Rejects :</div>
      <input
        class="col-span-2"
        bind:value={editedStyle.rejects}
        type="number"
        step="any"
        placeholder="Rejects"
      />
    </div>

    <div class="grid grid-cols-3 gap-2 items-center">
      <div>Reworks :</div>
      <input
        class="col-span-2"
        bind:value={editedStyle.reworks}
        type="number"
        step="any"
        placeholder="Reworks"
      />
    </div>

    <div class="grid grid-cols-3 gap-2 items-center">
      <div>Unit Price :</div>
      <input
        class="col-span-2"
        bind:value={editedStyle.uPrice}
        type="number"
        step="any"
        placeholder="Unit Price"
      />
    </div>

    {#if editStyleLoading}
      <div class="flex items-center justify-center btn btn-green-outline">
        <Circle size="25" color="rgb(16, 185, 129)" unit="px" />
        <span class="ml-4">Please wait...</span>
      </div>
    {:else}
      <div class="flex">
        <button
          style="width: 100%;"
          class="btn btn-green"
          on:click={handleEditStyle}
        >
          <i class="fas fa-check-circle mr-3" />
          Save
        </button>
        <button
          style="width: 100%;"
          class="ml-4 btn btn-gray"
          on:click={(e) => (showEditStyleForm = false)}
        >
          <i class="fas fa-times-circle mr-3" />
          Close
        </button>
      </div>
    {/if}
  </div>
</Modal>

<!-- EDIT MODAL -->
<style>
  .tr {
    display: flex;
    align-items: center;
    width: max-content;
    padding: 10px 20px;
  }
</style>
